import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Chart } from 'chart.js/auto';

@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class AssessmentComponent {
  score: number = 0;
  level: string = '';
  totalQuestions: number = 30;

  @ViewChild('assessmentForm') assessmentForm!: ElementRef;
  @ViewChild('myGauge') myGauge!: ElementRef;

  public questions = [
    "Utilizzate un firewall per proteggere la vostra rete aziendale?",
    "Avete una politica di gestione delle password che richiede password complesse e regolari aggiornamenti?",
    "Tutti i dispositivi utilizzati per accedere ai sistemi aziendali sono protetti da software antivirus?",
    "Il personale riceve regolarmente formazione sulla consapevolezza della sicurezza informatica?",
    "Avete un piano di risposta agli incidenti di sicurezza informatica?",
    "Eseguite regolarmente backup dei dati critici e li conservate in modo sicuro?",
    "Le connessioni remote alla rete aziendale sono protette da una VPN (Virtual Private Network)?",
    "Controllate regolarmente gli accessi ai sistemi critici per identificare attività sospette?",
    "Utilizzate l’autenticazione a due fattori (2FA) per l’accesso ai sistemi sensibili?",
    "Avete una procedura per gestire la sicurezza di dispositivi mobili utilizzati per scopi aziendali?",
    "Monitorate costantemente il traffico di rete per rilevare attività anomale?",
    "Eseguite test di penetrazione o vulnerability scan per identificare e correggere vulnerabilità?",
    "Gli aggiornamenti di sicurezza del sistema operativo e delle applicazioni sono effettuati tempestivamente?",
    "Avete una politica di accesso basata sui ruoli (RBAC) che limita l’accesso ai dati in base alla funzione lavorativa?",
    "Come gestite la sicurezza dei dati dei clienti e rispettate le normative sulla protezione dei dati (es. GDPR)?",
    "Conservate log di accesso e attività sui vostri server e dispositivi critici?",
    "Utilizzate un software di cifratura per proteggere dati sensibili sia a riposo che in transito?",
    "Avete un processo per verificare le identità prima di concedere l’accesso a sistemi o dati critici?",
    "Siete dotati di un sistema di prevenzione delle intrusioni (IPS) per rilevare attacchi in tempo reale?",
    "Avete procedure per il controllo e la gestione delle vulnerabilità delle applicazioni web aziendali?",
    "Verificate la sicurezza dei vostri fornitori e delle terze parti con cui collaborate?",
    "Effettuate test di phishing o simulazioni di attacchi per valutare la preparazione dei dipendenti?",
    "Utilizzate un sistema di gestione delle patch per mantenere aggiornati tutti i software utilizzati?",
    "Chi ha accesso fisico ai server aziendali e come viene monitorato l’accesso?",
    "Avete implementato politiche per l’utilizzo sicuro dei social media e della posta elettronica?",
    "Come gestite le credenziali obsolete o di ex dipendenti?",
    "Eseguite controlli periodici per rilevare eventuali violazioni di sicurezza?",
    "Gestite in modo sicuro le chiavi di crittografia?",
    "Gli amministratori IT utilizzano account separati per la gestione dei sistemi rispetto agli account normali?",
    "Avete stipulato una cyber assicurazione per coprire eventuali perdite o danni derivanti da incidenti informatici?"
  ];
  

  calculateScore(): void {
    // const form = document.forms['assessmentForm'];
    this.score = 0;

    for (let i = 1; i <= this.totalQuestions; i++) {
      const answer = this.assessmentForm.nativeElement['q' + i].value;
      if (answer === 'yes') {
        this.score++;
      }
    }

    if (this.score <= 6) {
      this.level = 'Basso';
    } else if (this.score <= 12) {
      this.level = 'Scarso';
    } else if (this.score <= 19) {
      this.level = 'Medio';
    } else if (this.score <= 25) {
      this.level = 'Efficiente';
    } else {
      this.level = 'Eccellente';
    }

    this.updateGauge();
  }

  updateGauge(): void {
    const ctx = this.myGauge.nativeElement.getContext('2d');
    // const ctx = (document.getElementById('myGauge') as HTMLCanvasElement).getContext('2d');
    if (ctx) {
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Basso', 'Scarso', 'Medio', 'Efficiente', 'Eccellente'],
          datasets: [{
            label: 'Livello di Sicurezza',
            data: [6, 6, 7, 6, 5, 70],
            backgroundColor: ['rgba(255, 99, 132, 0.2)', 'rgba(255, 159, 64, 0.2)', 'rgba(255, 205, 86, 0.2)', 'rgba(75, 192, 192, 0.2)', 'rgba(54, 162, 235, 0.2)', '#ff0000'],
            borderColor: ['rgba(255, 99, 132, 1)', 'rgba(255, 159, 64, 1)', 'rgba(255, 205, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(54, 162, 235, 1)', '#ff0000'],
            borderWidth: 1
          }]
        },
        options: {
          // circumference: Math.PI,
          // rotation: Math.PI,
          // cutout: '70%',
          plugins: {
            tooltip: { enabled: false },
            legend: { display: false }
          }
        }
      });
    }
  }
}
